import { Props_SnippetEvents } from "./Events.props";
import { Legacy_CompileMarkdown } from "../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler"
import AddToCalendarButton from "./AddToCalendarButton";

const SnippetEvents = (props: Props_SnippetEvents) => {
    const { heading, description, repeatable_eventsOptions } = props;
    const sortedEvents = repeatable_eventsOptions
        ?.map((event, index) => ({ event, index }))
        .sort((a, b) => {
            const orderA = parseFloat(a.event.order_number?.value ?? '');
            const orderB = parseFloat(b.event.order_number?.value ?? '');
            
            if (!Number.isNaN(orderA) && !Number.isNaN(orderB)) return orderA - orderB;
            if (!Number.isNaN(orderA)) return -1;
            if (!Number.isNaN(orderB)) return 1;
            return a.index - b.index;
        })
        .map(({ event }) => event);

    const eventsToRender = sortedEvents ?? [];

    return (
        <section className="snippet-events">
            <div className="snippet-events__container">
                <div className="snippet-events__header">
                    <h2 className={`snippet-events__heading ${heading.visibility?.value ? '' : 'snippet-events__heading--hidden'}`}>{ heading.content?.value }</h2>
                    {!!description.content?.value?.length && (
                        <div className="snippet-events__description">{Legacy_CompileMarkdown(description.content?.value)}</div>
                    )}
                </div>
                <div className="snippet-events__events-list">
                    {eventsToRender.map((item, index) => (
                        <div key={index} className="snippet-events__event-card">
                            {item.image && (
                                <img
                                    src={item.image.value}
                                    alt={item.imageAltText?.value || `Event ${index + 1}`}
                                    className="snippet-events__event-image"
                                    width={308}
                                    height={297}
                                />
                            )}
                            <div className="snippet-events__event-content">
                                <div className="snippet-events__event-date-location">
                                    {!!item.date.value?.length && (
                                        <p className="snippet-events__event-date">{item.date.value}</p>
                                    )}
                                    {!!item.location.value?.length && (
                                        <p className="snippet-events__event-location">{item.location.value}</p>
                                    )}
                                </div>
                                {!!item.title.value?.length && (
                                    <h3 className="snippet-events__event-title">{item.title.value}</h3>
                                )}
                                {!!item.descriptions.value?.length && (
                                    <div className="snippet-events__event-description">{Legacy_CompileMarkdown(item.descriptions.value)}</div>
                                )}
                                <AddToCalendarButton
                                    googleLink={item.google_calendar_link?.value || ''}
                                    outlookLink={item.outlook_calendar_link?.value || ''}
                                    icalendarLink={item.icalendar_link?.value || ''}
                                    addToCalendarLabel={item.add_to_calendar_label?.value}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default SnippetEvents;